import React, {useState, useEffect} from 'react';
import {gql} from '@apollo/client';
import {Grid, Box} from '@mui/material';
import styled from '@emotion/styled';
import produce from 'immer';
import dynamic from 'next/dynamic';
import { useTheme } from '@mui/material/styles';import { useMediaQuery } from '@mui/material';
import withWidth from '../../src/components/hoc/withWidth';
import {makeStyles} from '@mui/styles';
import qs from 'qs';
import {findIndex, get} from 'lodash';

import client from '../../src/graphql/client';
import {theme} from '../../src/themes/default-theme';

// utils
import filterDealerMotorHomes, {sellsMotorhomes, sellsCampervans} from '../../src/util/filterDealerMotorHomes'

// queries
import respImgFragment from '../../src/graphql/queries/resp-img';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';

// refactor
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorRangeData from '../../src/data-restructure/pages/range/range-listing-page';
import refactorContentBuilderData from '../../src/data-restructure/contentBuilder';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import CaravanCard from '../../src/components/navigation/CaravanCard';
import ContentBuilder from '../../src/containers/ContentBuilder';
import BannerPopup from '../../src/components/ui/BannerPopup';
import Modal from '../../src/components/ui/Modal';
import GalleryOverlay from '../../src/components/multimedia/GalleryOverlay';
import dlPush from '../../src/util/dlPush';
import Text from '../../src/components/typography'
import Quicklinks from '../../src/components/navigation/Quicklinks';
import RangeFilter from '../../src/components/navigation/RangeFilter';
import RangeCategory from '../../src/components/navigation/RangeCategorySection';

const RangeFilters = dynamic(() => import('../../src/components/filters/RangeFilters'))

const useStyles = makeStyles(() => ({
  modalOverlay: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  modalInner: {
    width: '100%',
    display: 'inline-block',
    position: 'relative',
    maxWidth: 1254,
  },
  modalClose: {
    top: '-40px',
    left: 10,
    marginBottom: '20px',
    position: 'absolute',

    [theme.breakpoints.up('md')]: {
      top: 20,
      bottom: 'auto',
      left: 'auto',
      right: 20,
      marginBottom: 0,
    }
  }
}));

const CaravanCards = styled.div`
  max-width: 1200px;
  margin: 30px auto 25px;

  ${theme.breakpoints.up('md')} {
    margin: 45px auto;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 60px auto;
  }
`

const CaravanCardContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;

  ${theme.breakpoints.up('md')} {
    max-width: 335px;
  }
`

const RangeFiltersContainer = styled.div`
  margin: 30px auto 25px;
  max-width: 1163px;

  ${theme.breakpoints.up('md')} {
    margin: 45px auto;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 60px auto;
  }
`

const FilterContainer = styled.div`
    margin-bottom: 30px;
    margin-top: 35px;
    ${theme.breakpoints.up('md')} {
        margin-bottom: 45px;
        margin-top: 60px;
    }
`
const RangeCategoryItem = styled.div`
    border-top: 1px solid ${theme.palette.lightGrey};
    margin-bottom: 30px;
    padding-top: 30px;
    &:last-child {
      margin-bottom: 0;
    }
`

const RangePage = (props) => {
  const [compareItems, setCompareItems] = useState([]);
  const maxToCompare = theme.isWidthUp('md', props.width) ? 3 : 2;
  const minToCompare = 2;
  const [curWidth, updateCurWidth] = useState(props.width);
  const [modal, openModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [compareUrl, updateCompareUrl] = useState('');
  const [showModelsInThumbnail, setShowModelsInThumbnail] = useState(false);
  const [filteredRanges, setFilteredRanges] = useState(props.ranges);

  const defaultFilterVals = {
    type: undefined,
    sleeps: undefined,
    mustHave: [],
    length: undefined,
    width: undefined,
    height: undefined,
    tareWeight: undefined
  }

  const [filterVals, setFilterVals] = useState(defaultFilterVals)
  
  useEffect(() => {
    // If width changes from md to sm/xs & compare items length is at max then clear items (2 items for sm, 3 for md up)
    if (
      ((compareItems.length === 3) && curWidth !== 'sm' && curWidth !== 'xs') && (props.width === 'sm' || props.width === 'xs')
    ) {
      setCompareItems([])
    }
    updateCurWidth(props.width);
  }, [props.width])


  const handleChange = (type, item) => {  
    console.log('handleChange type', item);  
    if (type === 'mustHave') {
      const arr = filterVals['mustHave'];
      if(!arr.includes(item.value)){          //checking weather array contain the id
        arr.push(item.value);               //adding to array because value doesnt exists
      } else{
        arr.splice(arr.indexOf(item.value), 1);  //deleting
      }
      setFilterVals({
        ...filterVals
      })
    } else {
      setFilterVals({
        ...filterVals,
        [type]: item.value === filterVals[type] ? undefined : item.value
      })
    }
  }

  useEffect(() => {

    if (JSON.stringify(filterVals) === JSON.stringify(defaultFilterVals)) {
      setShowModelsInThumbnail(false);
    } else {
      setCompareItems([]);
      setShowModelsInThumbnail(true);
    }

    console.log('_filt', props.ranges, filterVals);

    const _sellsCampervans = sellsCampervans();
    const _sellsMotorhomes = sellsMotorhomes();

    const filteredData = props.ranges.map(range => {

      const series = range.series.map((seriesItem) => {

        const models = seriesItem.models.filter((model) => {
          // height
          if(!filterVals.height || get(model, 'filterValues.height', 0) === filterVals.height) {
            return true
          }
        }).filter((model) => {
          // length
          if(!filterVals.length || get(model, 'filterValues.length', 0) === filterVals.length) {
            return true
          }
        }).filter((model) => {
          // width
          if(!filterVals.width || get(model, 'filterValues.width', 0) === filterVals.width) {
            return true
          }
        }).filter((model) => {
          // mustHave
          if(filterVals.mustHave.length === 0) {
            return true
          }
          let mustHave = false;
          // loop through to make sure all items match...
          const mustHaveLowerCase = get(model, 'filterValues.mustHave', []).map(item => item.toLowerCase());

          if (mustHaveLowerCase.length > 0) {
            console.log('mustHaveLowerCase', filterVals.mustHave, mustHaveLowerCase, model);
          }

          for (let i = 0; i < filterVals.mustHave.length; i++) {
            // filterVals.mustHave.every(item => {
            const item = filterVals.mustHave[i];
            if (mustHaveLowerCase.indexOf(item.toLowerCase()) === -1) {
              mustHave = false
              break;
            } else {
              mustHave = true
              continue;
            }
            // })
          }
          
          return mustHave;
        }).filter((model) => {
          // sleeps
          if(!filterVals.sleeps || get(model, 'filterValues.sleeps', 0) >= filterVals.sleeps) {
            return true
          } else {
            console.log('sleeps model', model.filterValues, filterVals.sleeps);
          }
        }).filter((model) => {
          // weight
          if(!filterVals.tareWeight || get(model, 'filterValues.tareWeight', 0) <= filterVals.tareWeight) {
            return true
          }
        }).filter((model) => {
          // type
          if(!filterVals.type || get(model, 'filterValues.type', 0) === filterVals.type) {
            return true
          }
        })

        return {
          ...seriesItem,
          models
        }
        
      }).filter(series => series.models.length > 0).filter((series) => {

        if (series.title && series.title.toLowerCase().indexOf('campervan') !== -1 && !_sellsCampervans ) {
          return false
        }
        if (series.title && series.title.toLowerCase().indexOf('motorhome') !== -1 && !_sellsMotorhomes ) {
          return false
        }
        return true
      })

      return {
        ...range,
        series
      }

    }).filter(range => {
      const display = filterDealerMotorHomes(get(range, 'range.learnMore.href', range.href))
      if (range.series.length > 0 && display) {
        return true
      }

      return false
    });

    setFilteredRanges(filteredData);

  }, [filterVals])

  const handleClearFilter = () => {
    setFilterVals(defaultFilterVals)
  }

  const handleNextClick = () => {
    dlPush({
      'event': 'jaycoEvent',
      'eventAction': 'CTA Click - Our Range - Compare',
      'eventCategory': 'Research',
      'eventLabel': 'Next'
    })
  }

  const handleCompare = (item, checked) => {

    console.log('handleCompare', item, checked);

    if (!item.rangeId) {
      return
    }

    if (checked && compareItems.length < maxToCompare) {
      // add
      const newState = produce(compareItems, draft => {
        draft.push(item);
      });
      setCompareItems(newState);
      updateParams(newState);
      item.title && dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Our Range - Compare',
        'eventCategory': 'Research',
        'eventLabel': item.title 
      })
    } else if (!checked) {
      // delete
      const newState = produce(compareItems, draft => {
        const compareIndex = findIndex(draft, {id: item.id});
        draft.splice(compareIndex, 1);
      });
      setCompareItems(newState);
      updateParams(newState);
    }
  }

  const updateParams = (compare) => {
    const compareData = compare.map(item => {
      return item.rangeId ? {
        range: item.rangeId,
        series: item.seriesId
      } : {
        range: item.id,
      }
    })

    const param = qs.stringify({items: compareData});

    updateCompareUrl(param)
  }

  let numberOfModels = 0;

  filteredRanges.forEach(range => {
    range.series.forEach(series => {
      numberOfModels += series.models.length;
    })
  })

  const classes = useStyles();

  console.log('range props', props);

  return (
    <>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          type="mediumBanner"
          headingSize="extraLarge"
        />
      }
      {props.filters &&
        <Grid container spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'} className="hasPadding">
            <Grid size={12}>
                <FilterContainer>
                    <RangeFilter
                        {...props.filters}
                        onChange={handleChange}
                        onClearFilter={handleClearFilter}
                        filterValues={filterVals}
                        numberOfModels={numberOfModels}
                    />
                </FilterContainer>
            </Grid>
        </Grid>
      }
      <Grid container spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'} className="hasPadding">
          <Grid size={12}>
              <Box px={2}>
                  {filteredRanges && filteredRanges.length > 0 ? filteredRanges.filter(item => {
                    const display = filterDealerMotorHomes(get(item, 'range.learnMore.href', item.href))
                    return display
                  }).map((item, index) => {
                      return (
                          <RangeCategoryItem key={item.id || index}>
                              <RangeCategory 
                                  {...item.range}
                                  series={item.series}
                                  showModelsInThumbnail={showModelsInThumbnail}
                                  onCompare={handleCompare}
                              />
                          </RangeCategoryItem>
                      )
                  })
                :
                  <Grid container direction={'row'} alignItems={'flex-start'}>
                    <Grid size={12}>
                      <Box px={2}>
                        <Text variant="body1" colour="charcoal" align="center">Sorry there are no results that match your criteria. Try adjusting your criteria to find a match.</Text>
                      </Box>
                    </Grid>
                  </Grid>
                }
              </Box>
          </Grid>
      </Grid>
      {props.contentBuilder && !process.env.DEALER_SITE &&
        <ContentBuilder
          data={props.contentBuilder}
          countryProps={props.countryProps}
        />
      }
      <>
        {process.env.DEALER_SITE &&
          <Quicklinks 
            dealerComponent={true}
          />
        }
      </>
      <BannerPopup 
        open={compareItems.length > 0}
        cta={{
          title: 'Next',
          href: `/compare?${compareUrl}`,
          disabled: compareItems.length >= minToCompare ? false : true
        }}
        onClick={handleNextClick}
        text={`Select: a maximum of ${maxToCompare} to compare`}
      />
    </>
  );
}

RangePage.propTypes = {

}

export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_RANGE_LISTING_PAGE = gql`
    query GET_RANGE_LISTING_PAGE($uri: String) {
      series(first: 10000) {
        nodes {
          seriesId
          uri
          acf_series {
            rangeAssigned
          }
        }
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          uri
          acf_floor_plan {
            modelRangeTypeFilter
            modelSeries {
              ... on Series {
                seriesId
                uri
                acf_series {
                  seriesRange {
                    ... on Range {
                      title
                      uri
                    }
                  }
                }
              }
            }
            seriesSpec
            modelLayoutName
            modelSleepAdultStandard
            modelSleepChildrenStandard
            modelSleepAdditionalStandard
            modelFloorPlanConfigurations {
              sleepAdult
              sleepChildren
              sleepAdditional
            }
            modelHasFridge
            modelHasShower
            modelHasToilet
            modelHasKitchen
            modelTravelLength
            modelTravelWidth
            modelTravelHeight
            modelWeightTare
          }
        }
      }
      rangeListingsPageBy(uri: $uri) {
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery('RangeListingsPage_AcfContentBuilder')}
        acf_domains {
          assignedDomains
        }
        acf_range_listings_page {
          rangeListingsPageRangeRef {
            ... on Range {
              id
              rangeId
              uri
              title
              acf_domains {
                assignedDomains
              }
              acf_range {
                rangeDescription
                rangePriceMaxAU
                rangePriceMaxNZ
                rangePriceMinNZ
                rangePriceMinAU
                rangeSleepingMax
                rangeImage {
                  ${respImgFragment}
                }
                rangeModelImage {
                  ${respImgFragment}
                }
                rangeSeriesRef {
                  ... on Series {
                    id
                    seriesId
                    uri
                    title
                    acf_series {
                      sleepingMax
                      seriesImage {
                        ${respImgFragment}
                      }
                      seriesFridge
                      seriesShower
                      seriesToilet
                      seriesSpecsRep {
                        seriesSpecRepTitle
                      }
                    }
                  }
                }
              }
              acf_content_builder {
                contentBuilder {
                  ... on Range_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner {
                    fieldGroupName
                    shbBannerImage {
                      ${respImgFragment}
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `

  const pageProps = await client.query({
    query: GET_RANGE_LISTING_PAGE,
    variables: {
      uri: 'range' + '?' + countryCode // add country code query string
    }
  });


  const data = await refactorRangeData(pageProps, countryCode.toUpperCase());

  // const contentBuilderData = pageProps ? get(pageProps, 'data.rangeListingsPageBy', null) : null;
  // const contentBuilder = contentBuilderData ? await refactorContentBuilderData(contentBuilderData, false, 'RangeListingsPage') : null;


  // seo
  const title = get(pageProps, 'data.rangeListingsPageBy.title', null);
  const seo = get(pageProps, 'data.rangeListingsPageBy.seo', null);
  const assignedDomains = get(pageProps, 'data.rangeListingsPageBy.acf_domains.assignedDomains', []); 

  data.meta = {
    title,
    seo,
    assignedDomains
  };

  // breadcrumbs
  data.breadcrumbs = await refactorBreadcrumbsData('/range', assignedDomains);
  
  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      ...data,
      // contentBuilder,
      // pageProps
      // contentBuilderData
    }
  }
}

export default withWidth(RangePage);
